import React, { useContext, useState } from "react";
import { context } from "../../context/context";
import DateInput from "../../components/common/inputs/DateInput";

function LoanFilter({ filterDataHandler }) {
  const { utils } = useContext(context);

  const [showDropDown, setShowDropDown] = useState(false);
  const [searchType, setSearchType] = useState("nationalId");

  const changeSearchType = (value) => {
    setSearchType(value);
    setShowDropDown(false);
    filterDataHandler({ page: 1, name: "", mobile: "" });
    document.getElementById("searchInput").value = "";
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full">
        <div className="flex relative">
          <label
            for="search-dropdown"
            className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
          >
            .
          </label>
          <button
            onClick={() => setShowDropDown(!showDropDown)}
            id="dropdown-button"
            className="flex-shrink-0 z-10 inline-flex items-center py-2.5 p-2 sm:px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"
            type="button"
          >
            {searchType == "nationalId" ? "کد ملی" : "کد ملی معرف"}
            <svg
              className="w-2.5 h-2.5 ms-2.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </button>

          <div
            onClick={() => setShowDropDown(!showDropDown)}
            className={`fixed top-0 right-0 z-10 w-full h-full ${
              !showDropDown && "hidden"
            }`}
          ></div>

          <div
            id="dropdown"
            className={`z-10 absolute bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 transition-all ${
              showDropDown
                ? "mt-12 visible opacity-100"
                : "top-0 mt-4 invisible opacity-0"
            }`}
          >
            <ul className="py-2 text-sm text-gray-700 dark:text-gray-200">
              <li>
                <button
                  onClick={() => {
                    changeSearchType("nationalId");
                  }}
                  type="button"
                  className="inline-flex justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  بر اساس کد ملی
                  {searchType == "nationalId" && (
                    <img
                      className="w-4 h-4"
                      src={require("./../../assets/images/tick-icon.png")}
                      alt=""
                    />
                  )}
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    changeSearchType("referrerUserNationalId");
                  }}
                  type="button"
                  className="inline-flex justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  بر اساس کد ملی معرف
                  {searchType == "referrerUserNationalId" && (
                    <img
                      className="w-4 h-4"
                      src={require("./../../assets/images/tick-icon.png")}
                      alt=""
                    />
                  )}
                </button>
              </li>
            </ul>
          </div>

          <div className="relative w-full">
            <input
              id="searchInput"
              onChange={(e) =>
                filterDataHandler({
                  page: 1,
                  [`${searchType}`]: e.target.value,
                })
              }
              type="search"
              className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-white rounded-e-lg border-s-gray-50 border-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
              placeholder="جستوجو"
              required
            />
            <button
              type="submit"
              className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
              <span className="sr-only">جستوجو</span>
            </button>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col sm:flex-row gap-6">
        <div className="w-full sm:w-4/12">
          <label
            className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`}
          >
            وضعیت
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, status: e.target.value })
            }
            id="status"
            className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>همه ی وضعیت ها</option>
            {utils?.LOAN_STATUS_VALUES?.length
              ? utils?.LOAN_STATUS_VALUES.map((item) => {
                  return <option value={item?.value}>{item?.name}</option>;
                })
              : null}
          </select>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-2 mt-1">
          <DateInput
            label={"از تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, from: e })}
          />
          <DateInput
            label={"تا تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, to: e })}
          />
        </div>
      </div>
    </div>
  );
}

export default LoanFilter;
